$(document).ready(function () {
  var IShide = getUrlParameter("hidebottommenu");
    if(IShide==1){
      $(".mobile-bar-bottom").hide();
      $(".footer").hide();
      $(".header").hide();
      setCookie('hidebottommenu', 1, 1);
    }
    else{
      
      var getCookieValue = getCookie('hidebottommenu');
      if(getCookieValue==1){
         $(".mobile-bar-bottom").hide();
          $(".footer").hide();
          $(".header").hide();
         setCookie('hidebottommenu', 1, 1);
      }
      else{
        setCookie('hidebottommenu', null, 0);
      }
    }

    
    

      function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };
  
  var hdd = $('.swatch.colo-custom').attr('data-colo-handle');
      $.get('/collections/all/'+hdd+'?view=colo-products&sort_by=title-ascending',function(d){
      $('.swatch.colo-custom').html(d);
      var c = $('.swatch.colo-custom').attr('data-colo-id');
      $('.swatch.colo-custom [data-pd="'+c+'"]').find('input').prop('checked',true);
      $('.swatch.colo-custom input[type="radio"]:checked').parents('.custom-link-pdp').addClass('colo-selected');
    });
  
   $('body').on('click','.custom-link-pdp',function(e){
     e.preventDefault();
     var link = $(this).attr('href');
     console.log(link);
     window.location.href = link;
   });

  
  function setCookie(name, value, days) {
  var expires = '';
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = '; expires=' + date.toUTCString();
  }
  document.cookie = name + '=' + value + expires + '; path=/';
}
function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
  cartSlider();
  
  function slider_arrow() {
    var sl_arrow = $('.pr_card_img').outerHeight() / 2;
    $('.product_slider .swiper-button-next, .product_slider .swiper-button-prev').css("top", sl_arrow);
  }

  function header_height() {
    var height_head = $('.header').outerHeight();
    $('.wrapper').css("margin-top", height_head);
  }

  function shop_slider_arrow() {
    var shop_sl_arrow = $('.pr_by_item').outerHeight() / 2;
    $('.pr_by_cte .swiper-button-next, .pr_by_cte .swiper-button-prev').css("top", shop_sl_arrow);
  }

  //PDP BANNER HEIGHT
  function pdp_banner_height() {
    var pdp_banner_ht = $(window).outerHeight();
    $('.pdp_main_bg_img').css("height", pdp_banner_ht);
    $('.pdp_hero_section .sticky').css("margin-top", pdp_banner_ht + 56);
  }
  pdp_banner_height();

  //MENU TOGGAL
  slider_arrow();
  header_height();
  shop_slider_arrow();

  $(window).on('load resize orientationchange', function () {
    slider_arrow();
    header_height();
    pdp_banner_height();
  });

  //HEADER STICKY
  $(window).scroll(function () {
    var banner_height_sl = $(window).outerHeight() - $('.checkout_info_sl').outerHeight() - 80;
    var sticky = $('.header'),
      scroll = $(window).scrollTop();

    if (scroll >= banner_height_sl) sticky.addClass('fixed');
    else sticky.removeClass('fixed');
  });

  if (!$('body').hasClass('template-index')) {
    $(window).scroll(function () {
      var sticky = $('.header'),
        scroll = $(window).scrollTop();

      if (scroll >= 200) sticky.addClass('fixed');
      else sticky.removeClass('fixed');
    });
  }

  
  

  //MINI CART OPEN
  $("body").on('click', '.cart_drawer a', function () {
    $('.mini_cart_wrap, body').addClass('active');
  });
  $("body").on('click', '.mini_cart_overlay, .close_cart', function () {
    $('.mini_cart_wrap, body').removeClass('active');
  });


  //SEARCh ACTIVE
  $("body").on('click', '.search>a', function () {
    $('.hd_search_main, body, .header, .menu_overlay').toggleClass('active_search');
    $('.has-children, .header, .menu_overlay, body').removeClass('active_menu');
    $('.mobile-bar-bottom li.search').toggleClass('active');
    $('.bottom-icon').not(this).removeClass('active');
  });

  $("body").on('click', '.menu_overlay', function () {
    $('.hd_search_main, body, .header, .menu_overlay').removeClass('active_search');
    $('.mobile-bar-bottom li.search').removeClass('active');
  });

  //FILTER ACTIVE
  $("body").on('click', '.filter_open_link a', function () {
    $('.col_filter_drawer, body').addClass('active');
  });

  $("body").on('click', '.col_fl_close, .filter_overlay', function () {
    $('.col_filter_drawer, body').removeClass('active');
  });

  //MEGAMENU OPEN mitul
  $("body").on('click', '.acnav__label', function () {
    $(".header_mid_inner .has-children").addClass("active_menu");
    $(".menu_overlay").addClass("active_menu");
    $("body").addClass("active_menu");
     var newWindowWidth = $(window).width();
      if (newWindowWidth > 1081) {
      $(".header").addClass("active_menu");  
      }
  });
  $(".acnav__label,.menu_overlay").on("click", function() {
    $(".header_mid_inner .has-children").removeClass("active_menu");
    $(".menu_overlay").removeClass("active_menu");
    $(".header").removeClass("active_menu");
    $("body").removeClass("active_menu");
  });

  // inner menu mitul
  $("body").on('click', '.nav__label', function () {
    $(this).parents('.has-children').addClass("active_menu");
  });
  $("body").on('click', '.menu_back_btn', function () {
    $(".has-children").removeClass("active_menu");
  });
  // HERO-SLIDER
  var swiper = new Swiper(".hero_slider ", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".hero_slider .swiper-pagination",
      clickable: true,
    },
  });


  // HERO-INFO-SLIDER
  var swiper = new Swiper(".check_slider_inner", {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".check_slider_inner .swiper-pagination",
      clickable: true,
    },
  });

   // SHOP-BY-SEARCH-SLIDER start
    var swiper = new Swiper(".pr_by_category .pr_by_cte", {
      slidesPerView: 6,
      spaceBetween: 33,
      slidesPerGroup: 6,
      navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
      },
      pagination: {
          el: ".pr_by_category .pr_by_cte .swiper-pagination",
          clickable: true,
      },
      breakpoints: {
          300: {
              slidesPerView: 2,
              slidesPerGroup: 1,
          },
          425: {
              slidesPerView: 3,
              slidesPerGroup: 1,
          },
          525: {
              slidesPerView: 4,
              slidesPerGroup: 1,
          },
          768: {
              slidesPerView: 5,
              slidesPerGroup: 1,
          },
          1080: {
              slidesPerView: 6,
              slidesPerGroup: 6,
          },
      },
  });

  // BESTSALLER SLIDER
  var swiper = new Swiper(".product_slider", {
    slidesPerView: 3,
    spaceBetween: 0,
    slidesPerGroup: 3,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      300: {
        slidesPerGroup: 1,
        slidesPerView: 2,
      },
      640:{
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
    },
  });

  //NICE SELECT
  $('.nice-select').each(function () {
    var select = $(this),
      name = select.attr('name');
    select.hide();
    select.wrap('<div class="nice-select-wrap"></div>');
    var parent = select.parent('.nice-select-wrap');
    parent.append('<ul id=' + name + ' style="display:none"></ul>');
      var selected = $('.nice-select').find(":selected").val();
    select.find('option').each(function () {
      var option = $(this),
        value = option.attr('value'),
        label = option.text();
      if (option.is(":first-child")) {
        $('<a href="javascript:void(0)" class="drop">' + label + '</a>').insertBefore(parent.find('ul'));
      } else if(selected == value){
        var shortBy = $('.nice-select').find('[value="sort-by"]').text();
        var niceOption = $(this),
        text = niceOption.text();        
        parent.find('.drop').text( shortBy + ' - ' + text).addClass('filter-active');
        parent.find('ul').append('<li><a class="active sort_active" href="javascript:void(0)" id="' + value + '" value="' + value + '"><span></span>' + label + '</a></li>');
      } else {
        parent.find('ul').append('<li><a href="javascript:void(0)" id="' + value + '" value="' + value + '"><span></span>' + label + '</a></li>');
      }
    });
    parent.find('a').on('click', function (e) {
      parent.toggleClass('down').find('ul').slideToggle(300);
      e.preventDefault();
    });
    parent.find('ul a').on('click', function (e) {
      var shortBy = $('.nice-select').find('[value="sort-by"]').text();
      var niceOption = $(this),
      value = niceOption.attr('id'),
      text = niceOption.text();
      select.val(value);
      parent.find('.drop').text( shortBy + ' - ' + text).addClass('filter-active');
      e.preventDefault();
      $(this).closest('#sort').find('li a').removeClass('active sort_active');
      $(this).addClass('active sort_active');
    });
  });

  // For Sort-by Filter Select Box in collections page
  //  $('body').on('click','.nice-select-wrap ul#sort li',function(e){
  //    e.preventDefault();
  //    var url = location.pathname; 
  //    var criteria = $(this).find('a').attr('id');
  //    var url_path = url +'?sort_by=' + criteria ;

  //  if($($(this).find('a')).hasClass('active')){
  //     $('.col_tl_left .flex .filter_tag').removeClass('filter-active'); 
  //   } 
     
  //    $.ajax({
  //       url: url_path,
  //       type:'GET',
  //       success: function(data) {
  //         var data = $(data).find('.col_grid_inner').html();
  //         $('.col_grid_inner').html(data);
  //         window.history.pushState({}, '', url_path);
  //       }
  //   });
  // });


  // For Sort-by filter button (Best Selling, Featured)
  $('body').on('click','.col_tl_left .flex .filter_tag',function(e){
    e.preventDefault();
    $('.nice-select-wrap').removeClass('down');
    $('.nice-select-wrap ul#sort').hide();
    $('.col_tl_left .flex .filter_tag').removeClass('filter-active sort_active');
    // var filter = $(this).data('filter');
    $(this).addClass('filter-active sort_active');
    if($(this).hasClass('filter-active sort_active')){
     $('ul#sort a').removeClass('active sort_active');
    $('.drop').removeClass('filter-active sort_active');
    } 
    // $.ajax({
    //     url: filter,
    //     type:'GET',
    //     success: function(data) {
    //       var data = $(data).find('.col_grid_inner').html();
    //       $('.col_grid_inner').html(data);
    //       window.history.pushState({}, '', filter);
    //     }
    // });
  });

  $("body").on('click', '.col_fl_item_title', function () {
    $(this).next().slideToggle();
    $(this).toggleClass('open');
  });

  //For Mini-cart product qty box js
function catCountUpadte() {
  $.getJSON('/cart.js', function (data) { 
    var newCount = data.item_count;
    $('.cart_count').text(data.item_count);
      if (newCount == 0 ) {
        $('.cart_count').addClass('empty_cart');
      }else{
        $('.cart_count').removeClass('empty_cart');
      }
  });
}
function miniCartUpdate() {
  $.get("/cart?view=mini-cart", function(cart) {
     var html = $(cart).find('.drawer_main').html();
     $('.drawer_main').html(html);
     cartSlider();
   });
}

  function mainCartUpdate() {
    $.get("/cart?view=main-cart", function(cart) {
       var html = $(cart).find('.thank_wrp').html();
       $('.thank_wrp').html(html);
       cartSlider();
     });
  }


  /*------------------  24-08-2024 START  ------------------------------------*/
  $('body').on('click','.dr_qty_btn .qty_btn',function(e){
     e.preventDefault();
    var qty = parseInt($(this).parent('.dr_qty_btn').find('input').val());
    var invonter_qty = parseInt($(this).parent('.dr_qty_btn').find('input').attr('data-invontry'));
    
    if($(this).hasClass('qty_plus')) {
     if (qty < invonter_qty) {
      qty++;
     }
    }else {
      if(qty > 0) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.dr_qty_btn').find('input').val(qty);

    var $input = $(this).parent('.dr_qty_btn').find('.qty_plus');
    if (qty < invonter_qty) {
        $input.addClass('qty_disabled');
    } else {
        $input.removeClass('qty_disabled');
    }
    // cart drawer 
     var variantId = $(this).parent('.dr_qty_btn').attr('data-variant');
     $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json', 
      data: { quantity: qty, id: variantId },
      success: function (cart) {
         catCountUpadte();
         miniCartUpdate();
         mainCartUpdate();
          if($('.shipping_protection').hasClass('protection_activated')){
            console.log('aleady have');
          }else{
            addShippingProtection();
          }
        }
      });
      $.getJSON('/cart.js', function(c){
          var hasInsurance=0;
          for (let iname of c.items) {
            if(iname.id!=41747954106538){
              hasInsurance=1;
            }
          }
          if(hasInsurance==0){
            removeShippingProtection();
          }
      });
  });
  /*------------------  24-08-2024 END  ------------------------------------*/

  //For Mini-cart product remove js
  $('body').on('click','.remove_items',function(e){
    e.preventDefault();
    var variantObject = {};
    var removevariantid = $(this).attr('data-variant');
    variantObject[removevariantid] = 0;
    var jsonObject = {}
    jsonObject['updates'] = variantObject;
    $.ajax({
      type: "post",
      url: "/cart/update.js",
      data: jsonObject,
      dataType: "json",
      success: function (cart) { 
         catCountUpadte();
         miniCartUpdate();
         mainCartUpdate();
        $.getJSON('/cart.js', function(c){
            var hasInsurance=0;
            for (let iname of c.items) {
              if(iname.id!=41747954106538){
                hasInsurance=1;
              }
            }
          if(hasInsurance==0){
            removeShippingProtection();
            
          }
          });
        }
    });
 });

  // For Product-grid add to cart button js
  $('body').on('click','.add_btn',function(e){ 
    e.preventDefault();
    var form_data = $(this).closest('form').serialize();
    // var variantId = $(this).closest('form').find('[name="id"]').val();
    // var qtyProduct = $(this).closest('form').find('[name="quantity"]').val();
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data:form_data,
      dataType: 'json', 
      success: function (cart) {
          $('.add_btn').closest('form').find('[name="quantity"]').val('1');
          $('.mini_cart_wrap, body').addClass('active');
          $.get("/cart?view=mini-cart", function(minicart) {
            var html = $(minicart).find('.drawer_main').html();
            $('.mini_cart_wrap').find('.drawer_main').html(html);
            cartSlider();
          });
          catCountUpadte();
          if($('.shipping_protection').hasClass('protection_activated')){
            console.log('aleady have');
          }else{
            addShippingProtection();
          }
        }
    });
  }); 
  
//  product page qty update 
  $('body').on('click','.pdp_qty_btn .qty_btn',function(e){
     e.preventDefault();
    var qty = parseInt($(this).parent('.pdp_qty_btn').find('input').val());
    if($(this).hasClass('qty_plus')) {
      qty++;
    }else {
      if(qty > 1) {
        qty--;
      }
    }
    qty = (isNaN(qty))?1:qty;
    $(this).parent('.pdp_qty_btn').find('input').val(qty);
    $(this).closest('form').find('[name="quantity"]').val(qty);
  });

  
  // For Newsletter Validation
  $("body").on('click', '#Subscribe', function () {
      var hasValue = false;
      if ($('.field__input').val() !== '') {
        hasValue = true; 
      }
      if (!hasValue) {
        $('.error').show();
      } else {
        $('.error').hide();
      }  
      var email = $('#NewsletterForm').val();
      if(IsEmail(email) === false) {
        $('#NewsletterForm').next().show();
        return false;
      }
      $.post("", $("#ContactFooter").serialize(), function(response) {
        return false;
      });
  });

   // CART-COLLECATION-SLIDER
  function cartSlider(){
    var swiper = new Swiper(".mini_cart_slider", {
      slidesPerView: 3,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".mini_cart_slider .swiper-pagination",
        clickable: true,
      },
       breakpoints: {
        767: {
        slidesPerView: 3,
        },
        300: {
        slidesPerView: 2,
        },
      }
    });
  }

   // LOGOS-SLIDER
   var swiper = new Swiper(".logos_wpr_slider", {
      slidesPerView: 9,
      spaceBetween: 15,
      breakpoints: {
        1440: {
          slidesPerView: 9,
        },
        991: {
          slidesPerView: 5,
        },
        767: {
          slidesPerView: 4,
        },
        320: {
          slidesPerView: 2.5,
        },
      }
    });

   // INSTA-SLIDER
   var swiper = new Swiper(".insta_slider", {
      slidesPerView: 5,
      spaceBetween: 15,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1080: {
          slidesPerView: 5,
        },
        767: {
          slidesPerView: 4,
        },
        526: {
          slidesPerView: 3,
        },
        320: {
          slidesPerView: 1.5,
        },
      }
    });

   // PDP ACCODIAN START
  $("body").on('click', '.pdp_accordion_title', function () {
    if (!$(this).hasClass('active')) {
        $(this).next().slideDown();
        $(this).addClass('active');
    } else {
        $(this).next().slideUp();
        $(this).removeClass('active');
    }
});
   // GIFT SLIDER
    var gift_thoughtful_slider = new Swiper(".gift_thoughtful_slider", {
      slidesPerView: 1.35,
      spaceBetween: 15,
      pagination: {
          el: '.swiper-pagination.thoughtful_pagination',
          clickable: true,
        },
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 0,
        }
      }
    });
    // GIFT HERO SLIDER
    var gift_thoughtful_slider = new Swiper(".gift_hero_slider", {
      slidesPerView: 4,
      spaceBetween: 30,
      // loop: true,
      // mousewheelControl: false,
      // allowTouchMove: false,
      // speed: 1000,
      // autoplay: {
      //   delay: 0,
      //   enabled: true,
      // }
    });
    
//  pdp_hero_slider
  (function() {
    'use strict';
    const breakpoint = window.matchMedia( '(min-width:1081px)' );
    let mySwiper;
    const breakpointChecker = function() {
      if ( breakpoint.matches === true ) {
      if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
      return;
        } else if ( breakpoint.matches === false ) {
          return enableSwiper();
        }
    };
    const enableSwiper = function() {
      mySwiper = new Swiper('.pdp_gero_slider', {
        spaceBetween: 0,
        slidesPerView: 1,
        pagination: {
          el: ".pdp_hero_section .swiper-pagination",
          clickable: true,
        },
        });
          var galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 0,
            slideToClickedSlide: true,
             slidesPerView: 1,
          });
        mySwiper.controller.control = galleryThumbs;
        galleryThumbs.controller.control = mySwiper;
    };
    breakpoint.addListener(breakpointChecker);
    breakpointChecker();
  })(); 
  
  // pdp candle_link click
  $("body").on('click', '.candle_link', function () {
    // e.preventDefault(e);
    $('.candle_link').removeClass('bg_over');
    $(this).addClass('bg_over');
  });
  
  
  // popup js
  $("body").on('click', '.pro_detail_lear a', function (e) {
    e.preventDefault(e);
    $('.candel_care_popup').addClass('is-open');
    $('.care_pro_overlay').addClass('is-open');
    $('.header').addClass('is-open');
    $('.wrapper').addClass('is-open');
    $('body').addClass('is-open');
  });
  $("body").on('click', '.pro_close,.care_pro_overlay', function (e) {
    $(".candel_care_popup, .care_pro_overlay , body ").removeClass("is-open");
    $('.care_pro_overlay').removeClass('is-open');
    $('.wrapper').removeClass('is-open');
    $('.header').removeClass('is-open');
    $('body').removeClass('is-open');
  });

  // Shipping & Returns popup js
  $("body").on('click', '.footer_menu_item ul li .shipping_popup,.free_shiping_inner svg', function (e) {
    e.preventDefault(e);
    $('.terms_services_popup').addClass('is-open');
    $('.footer_care_pro_overlay').addClass('is-open');
    $('.wrapper').addClass('is-open');
    $('body').addClass('is-open');
  });
  $("body").on('click', '.pro_close,.footer_care_pro_overlay', function (e) {
    $(".terms_services_popup, .footer_care_pro_overlay , body ").removeClass("is-open");
    $('.footer_care_pro_overlay').removeClass('is-open');
    $('.wrapper').removeClass('is-open');
    $('body').removeClass('is-open');
  });

  // FAQ page js
  $("body").on('click', '.faq_accordion_title', function (e) {
    $('.faq_accordion_title').removeClass('active');
    $('.faq_content_wp').slideUp().removeClass('current');
    if (!$(this).next().is(':visible')) {
        $(this).next().slideDown().addClass('current');
        $(this).addClass('active');
    }
  });

  

// faq page tabbing js

   $( ".faq_accordion_item" ).each(function() {
     $(this).addClass('active');
  });
  $("body").on('click', '.faq_link li', function (f) {
    f.preventDefault(); 
      var value = $(this).find("a").attr('href');
      $('li a.active').removeClass('active');
      $(this).find("a").addClass('active');
      $( ".faq_accordion_item" ).each(function() {
        var dataGet = $(this).attr('data_id');
        var idGet = '#' + dataGet
          if (value == idGet ) {
            $(this).addClass('active');
          } else if (value == '#taball') {
               $(this).addClass('active');
          } else {
               $(this).removeClass('active');
          }
      });
  });

  // contact validation

  $('.field__input_contact').on('blur', function(event) {
    var inputValue = this.value;
    if (inputValue) {
       $(this).next().addClass('input_value_exists');
    } else {
      $(this).next().removeClass('input_value_exists');
    }
  });
  
  $(".contact_main input, textarea").change(function(){
    $('.field__input_contact').each(function() {
      var Input = $(this).val(); 
      if (Input !== '') {
        $('.contact_from .lavender_btn').addClass('submit_form');
      }else{
        $('.contact_from .lavender_btn').removeClass('submit_form');
      }
    });
  });
 

  $("body").on('change', '.contact_main input', function () {
    var inputs = $('.field__input_contact');
    var hasValue = false;
    inputs.each(function() {
      if ($(this).val() !== '') {
        hasValue = true; // value available in input
        return false; // Exit the loop early
      }
    });
    if (!hasValue) {
      $('.error').show();
      return false; // Prevent form submission
    } else {
      $('.error').hide();
    } 
  });

  $("body").on('click', '.contact_from .lavender_btn', function (e) {
      $('.error').hide(); 
      var name = $('#ContactForm-name').val();
      var email = $('#ContactForm-email').val();
      var phoneNumber = $('#ContactForm-phone').val();
      var textMassage = $('#ContactForm-body').val();
      if (name === '') {
        $('#ContactForm-name').next().next().show();
        return false;
      }
      if(IsEmail(email) === false) {
        $('#ContactForm-email').next().next().show();
        return false;
      }
      if (Isnumber(phoneNumber) === false) {
        $('#ContactForm-phone').next().next().show();
        return false;
      }
      if (textMassage === '') {
        $('#ContactForm-body').next().next().show();
        return false;
      }
      $.post("", $("#ContactForm").serialize(), function(response) {
        return false;
      });
    });
    function IsEmail(email) {
      var regexE = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
     if (!regexE.test(email)) {
        return false;
      } else {
        return true;
      }
    }
    function Isnumber(phoneNumber) {
      var regex = /^\d{10}$|^\d{3}-\d{3}-\d{4}$/;
      if (!regex.test(phoneNumber)) {
        return false;
      } else {
        return true;
      }
    }

    // textarea height
    function auto_grow(element) {
      element.style.height = "5px";
      element.style.height = (element.scrollHeight) + "px";
    }
    $('body').on('click','.sticky_add',function(e){
      e.preventDefault();
     $('.pdp_primary_btn.add_btn').trigger('click')
    });

  
//  whishlist product grid
  
$('body').on('click','.whishlist_pr',function(e){
    e.preventDefault();
    if ($(this).hasClass('svgpath')) {
         $(this).removeClass('svgpath');
         var handleProductValueremove = $(this).data('product-handle');
         var productHandlessvg = $(this).closest('.remove_colvgrid_inner').find('.product_card').data('product');
         var getRemove = getCookie('WhishlistProduct');
        if (getRemove) {
            var productHandlep = getRemove.split(',');
            var index = productHandlep.indexOf(productHandlessvg);
            if (index !== -1) {
              productHandlep.splice(index, 1);
              var updatedProductHandlesp = productHandlep.join(',');
              setCookie('WhishlistProduct', updatedProductHandlesp, 1);
               $(this).closest('.wish_col_grid_inner .product_card').remove();
               $(this).closest('.accoubnt_page .swiper-slide').remove();
               if (productHandlep.length == 0) {
                   $('.bestsaller_main.order-history').hide();
                  $('.text-center.show_message_product').show();
                }
            }
            
            var productHandlew = getRemove.split(',');
            var indexcheck = productHandlew.indexOf(handleProductValueremove);
            if (indexcheck !== -1) {
              productHandlew.splice(indexcheck, 1);
              var updatedProductHandlesw = productHandlew.join(',');
              setCookie('WhishlistProduct', updatedProductHandlesw, 1);
              $(this).removeClass('svgpath');
            }
           $('.data_count').html('(' + productHandlew.length + ')');
        }
          
      
    } else {
        $(this).addClass('svgpath');
        var handleProductValue = $(this).data('product-handle');
        var getCookieValue = getCookie('WhishlistProduct');
        var handleProduct = [handleProductValue];
        if (getCookieValue) {
            handleProduct.push(getCookieValue);
        }
       setCookie('WhishlistProduct', handleProduct.join(','), 1);
    }
});

  
  // selected whislist button fill color
var loadproductHandw = getCookie('WhishlistProduct');
var productHandlessplitw = loadproductHandw.split(',');
 $.each(productHandlessplitw, function (i, O){
  jQuery.getJSON('/products/' + productHandlessplitw[i] + '.js', function (product) {
      $(".product_card").each(function() {
       var getHandle = $(this).data('product');
        if (getHandle == product.handle) {
         $(this).find('.whishlist_pr').addClass('svgpath');
        }
      });
  });
});

  
  // html print in whislist page  
var loadproductHand = getCookie('WhishlistProduct');
var productHandlessplit = loadproductHand.split(',');
  // console.log(productHandlessplit.length,"productHandlessplit");
  $('.data_count').html('(' + productHandlessplit.length + ')');
    if (!loadproductHand) {
       $('.text-center.show_message_product').show();
       $('.bestsaller_main.order-history').hide();
    }
  $.each(productHandlessplit, function (i, O){
  jQuery.getJSON('/products/' + productHandlessplit[i] + '.js', function (product) {
    $.get('/products/' + productHandlessplit[i] + '?view=alternate-product-grid', function(product1) {
      $(product1).each(function(i,o){
           var getdata = $(product1).html();
            $('.wish_col_grid_inner').append(getdata);
            $('.wish_col_grid_inner .whishlist_pr').addClass('svgpath');
            $('.accoubnt_page').append('<div class="swiper-slide">'+getdata+ '</div>');
            $('.accoubnt_page .whishlist_pr').addClass('svgpath');
          });
      });
  });
   
});



  
// aap wishlist close button
  $('body').on("click", ".remove_wishlist", function(e) {
  e.preventDefault();
    var dataRemovehandle = $(this).closest('.product_card ').data('product');
    var productHandlesStr = getCookie('WhishlistProduct');
     if (productHandlesStr) {
      var productHandles = productHandlesStr.split(',');
      var index = productHandles.indexOf(dataRemovehandle);
      if (index !== -1) {
        productHandles.splice(index, 1);
        var updatedProductHandlesStr = productHandles.join(',');
        setCookie('WhishlistProduct', updatedProductHandlesStr, 1);
        $(this).closest('.product_card').remove();
      }
      
      if (index == 0) {
        $('.text-center.show_message_product').show();
     } 
    }
    
     // if (index == 0) {
     //    $('.text-center.show_message_product').show();
     // }
  });
  
// search page value remove input
$('body').on("click", ".search_remove", function(e) {
  e.preventDefault();
  $(this).closest('.search_input ').find('[type="search"]').val('');
});
  
// pdp page sticky product title and price
  var $pdpAccordionMain = $(".pdp_accodian_main");
  if ($pdpAccordionMain.length > 0) {
  var from_set = $pdpAccordionMain.offset().top;
    $(window).scroll(function(e) {
      e.preventDefault();
      if ($(this).scrollTop() >= from_set) {
        $('.mobile_sticky').addClass("top_sticky");
        $('body').addClass("sticky_pdp");
      } else {
        $('.mobile_sticky').removeClass("top_sticky");
        $('body').removeClass("sticky_pdp");
      }
    });
  }

  // pdp height
  // var imageHeight = 0;
  // $('.pdp_hero_main_img').each(function() {
  //     imageHeight += $(this).outerHeight();
  // });
  // var product_info_height = $('.pdp_hero_right_inner').outerHeight();
  // var topValue = parseInt($('.pdp_hero_right').css('top'));
  // var heightDifference = Math.abs((product_info_height + topValue) - imageHeight);
  // if ($(window).width() > 768){
  //     if (product_info_height >= imageHeight) {
  //         var totalMargin = heightDifference + 80;
  //         $('.pdp_hero_section').css('margin-bottom', totalMargin + 'px');
  //     }
  // }
  
$("body").on('click', '.eye_icon', function (e) {
  $(this).toggleClass("eye-slash");
  var input = $($(this).attr("toggle"));
  if (input.attr("type") == "password") {
    input.attr("type", "text");
  } else {
    input.attr("type", "password");
  }
});

  $('.foce_show_title').hide();
  $("body").on('keyup', '#searchInput', function () {
    var q = $('#searchInput').val();
    var b = '&resources[type]=product'
    if ( q.length > 0 ) {
       $(".search_byproduct").hide();
       $('.foce_show_title').show();
       $('#searchResults').show();
    }else{
       $(".search_byproduct").show();
       $('.foce_show_title').hide();
       $('#searchResults').hide();
    }
    $.ajax('/search/suggest.json?q=' + q + b, {
      type: 'GET',
      dataType: 'json',
      success: function(response) {
        var productSuggestions = response.resources.results.products;
        if (productSuggestions.length > 0) {
          $("#searchResults").empty();
          $(productSuggestions).each(function(i) {
            if(i == 3){
              return false;
            }
            $("#searchResults").append(
              '<li><a href="'+ this.url +'">'+ this.title +'</a></li>'
            );
          });
        } else {
          $("#searchResults").empty().append(
            '<li><small>No Results Found</small></li>'
          );
        }
      }
    });
  });


// mobile menu js 
  $("body").on('click', '.mobile_hamburger_icon', function (e) {
      e.preventDefault(e);
      $('.mobile_menu').addClass('is-new');
      $('.mobile_overlay').addClass('is-new');
      $('.wrapper').addClass('is-open');
      $('body').addClass('is-open');
    });
  $("body").on('click', '.mobile_menu_close a,.mobile_overlay', function (e) {
      $('.has-children').removeClass('active_menu');
      $('.mobile_overlay').removeClass('is-new');
      $(".mobile_menu, .mobile_overlay , body ").removeClass("is-new");
      $('.wrapper').removeClass('is-open');
      $('body').removeClass('is-open');
    });

  
  //HEADER OPEN JS megamenu
 $("body").on('click', '.header_desk_megamenu', function () {
    $(this).toggleClass('active_menu');
    $('.header_center, body, .menu_overlay').toggleClass('active_menu');
  });
  $("body").on('click', '.menu_overlay', function () {
    $('.header_center, body, .header_desk_megamenu, .menu_overlay').removeClass('active_menu');
  });
  
 $("body").on('click', '#customer_logout_link', function () {
    $.ajax( $(this).attr('href'))
    .done(function() {
      window.location.href = "/account/login";
    });
    return false;
  });

 $("body").on('click', '.mobile_sticky .price', function () {
   $(".header").addClass("mobile_price_open");
 });
 $("body").on('click', '.cart .close_cart', function () {
   $(".header").removeClass("mobile_price_open");
 });

$('body').on('click','.mobile-bar-bottom .message,.chat-us-link,.chat-link',function(e){
  e.preventDefault();
  $('.mess_main').addClass('chat_active');
  $(".mess_chat_overlay").addClass('chat_active');
  $("body").addClass('chat_active');
  
});
$('body').on('click','.mess_main .mess_close,.mess_chat_overlay ',function(){
  $('.mess_main').removeClass('chat_active');
  $(".mess_chat_overlay").removeClass('chat_active');
  $("body").removeClass('chat_active');
  $('.mobile-bar-bottom').find('.bottom-icon.message').removeClass('active');
  localStorage.removeItem('Custom_chat');
}); 

$('body').on('click', '.mobile-bar-bottom .bottom-icon', function(e) {
  $('.bottom-icon').not(this).removeClass('active');
  $('.mobile-bar-bottom li.search').removeClass('active');
  $(this).toggleClass('active');
});


// Function to get a real time  
function updateDateTime() {
  var date = new Date();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // Handle midnight
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var dateTimeString = hours + ':' + minutes + ' ' + ampm; 
  $('.mess_for_inner:last').find('.mess_time').text(dateTimeString);
}

updateDateTime();
  
  
  // Shipping Protection -- START
  
  $('body').on('click','#shipping_protection',function(){
    if($(this).is(':checked')){
      addShippingProtection();
    }else{
      removeShippingProtection();
    }
  })

  function addShippingProtection(){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {
          id: 41747954106538,
          quantity:1
        },
        success: function(){
          miniCartUpdate();
          mainCartUpdate();
          catCountUpadte();
        }
      });
  }

    function removeShippingProtection(){
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: {
          id: 41747954106538,
          quantity:0
        },
        success: function(){
          miniCartUpdate();
          mainCartUpdate();
          catCountUpadte();
        }
      });
  }

  // Shipping Protection -- END


  // Chut Button dummy function
      function printUserText(value){
        var clientText = '<div class="mess_for_inner mess-user">' +
        '<span class="mess_time">9:35 am</span>' +
        '<div class="mess_text">' +
        '<span>'+value+'</span>' +
        '</div>' +
        '<div class="mess_round">' +
        '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 200 200">' +
        '<rect x=".11" y=".11" width="199.78" height="199.78" rx="99.89" ry="99.89" transform="translate(3.35 -3.24) rotate(1.89)"></rect>' +
        '<g>' +
        '<path d="M66.34,149.41h57.4c1.94-1.31,3.78-2.75,5.52-4.3h-58.62V60.99c-1.48.79-2.91,1.64-4.3,2.57v85.85Z"></path>' +
        '<path d="M84.74,131.01h57.4c1.94-1.31,3.78-2.75,5.52-4.3h-58.62V42.58c-1.48.79-2.91,1.64-4.3,2.57v85.85Z"></path>' +
        '</g>' +
        '</svg>' +
        '</div>' +
        '</div>';
         $('.mess_for_inner:last').after(clientText);
         $('.mess_val').val('');
      } 

      function printBotText(value_bot){
        var date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // Handle midnight
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var dateTimeString = hours + ':' + minutes + ' ' + ampm; 
        
        var botText = '<div class="mess_for_inner mess-bot">' +
        '<span class="mess_time">'+dateTimeString+'</span>' +
        '<div class="mess_round">' +
        '<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 200 200">' +
        '<rect x=".11" y=".11" width="199.78" height="199.78" rx="99.89" ry="99.89" transform="translate(3.35 -3.24) rotate(1.89)"></rect>' +
        '<g>' +
        '<path d="M66.34,149.41h57.4c1.94-1.31,3.78-2.75,5.52-4.3h-58.62V60.99c-1.48.79-2.91,1.64-4.3,2.57v85.85Z"></path>' +
        '<path d="M84.74,131.01h57.4c1.94-1.31,3.78-2.75,5.52-4.3h-58.62V42.58c-1.48.79-2.91,1.64-4.3,2.57v85.85Z"></path>' +
        '</g>' +
        '</svg>' +
        '</div>' +
        '<div class="mess_text">' +
        '<span><span>'+value_bot+'</span>' +
        '</div>' +
        '</div>';
        $('.mess_for_inner:last').after(botText);
       
      }


      // Set item with expiry time of 1 day (24 hours)
      function setWithExpiry(key, value, ttl) {
          const now = new Date();
          const item = {
              value: value,
              expiry: now.getTime() + ttl * 1000 * 60 * 60 * 24 // Convert days to milliseconds
          };
          localStorage.setItem(key, JSON.stringify(item));
      }
      
      // Get item and check if it's expired
      function getWithExpiry(key) {
          const itemStr = localStorage.getItem(key);
          if (!itemStr) {
              return null;
          }
          const item = JSON.parse(itemStr);
          const now = new Date();
          if (now.getTime() > item.expiry) {
              localStorage.removeItem(key);
              return null;
          }
          return item.value;
      }
  
      
      function searchingText(value_bot){
        $('.mess_for_inner:last').find('.mess_text').html('<span>'+value_bot+'</span>');
       
      }
      function chatScroll(){
        $(".mess_center_chat").animate({ scrollTop: $(document).height() }, 1000);
      }          
      function convertLinksToHTML(text) {
          var urlRegex = /(https?:\/\/[^\s)]+)/g; 
          var htmlText = text.replace(urlRegex, function(url) {
              return '<a href="' + url + '">' + url + '</a>';
          });
          return htmlText;
      }
  
      // Retrive the chat data here
      var get_chat_data = getWithExpiry('Custom_chat');
      if (get_chat_data !== undefined && get_chat_data !== null) {
         $('.mess_center_chat').html(get_chat_data);
      }


    $('body').on('click','.mess_submit',function(e){
      
      e.preventDefault();
      if($('.mess_val').val() != ""){
      // debugger;
      var ajaxReq = 'ToCancelPrevReq';
      var value = $('.mess_popup .mess_val').val();
      printUserText(value);
      updateDateTime();
      chatScroll();
      if ($("#threadid").val() != "") {
      	ajaxReq = $.ajax({
                url: "https://lifeinlilac.mayurpanchal.net/chat/api",
                data: { "query_text": value ,"thread_id": $("#threadid").val()},
                type: "POST",
                beforeSend: function () {
                    if (ajaxReq != 'ToCancelPrevReq' && ajaxReq.readyState < 4) {
                        ajaxReq.abort();
                    }
                    setTimeout(function(){
                      // printBotText('Typing');
                      chatScroll();
                    },3000);
                },
                success: function (result) {
                  // debugger;
                  console.log("result",result);
                    if (result.Status == 1) {
                          $("#threadid").val(result.thread_id);
                         
                          setTimeout(function(){
                            printBotText(result.Message);
                            updateDateTime();    
                            
                            $('.mess_text span').each(function() {
                                var text = $(this).text();
                                var htmlText = convertLinksToHTML(text);
                                $(this).html(htmlText);
                            });
                            
                            // check the new text
                            var html = $('.mess_center_chat').html();
                            // overwrite the old text
                            setWithExpiry('Custom_chat', html, 1);
                          },3000);  
                            
                        }    
                      },
                      error: function (result) {
      					// debugger;
                      },
                   });
          }else {
          ajaxReq = $.ajax({
            url: "https://lifeinlilac.mayurpanchal.net/chat/api",
            data: { "query_text": value },
            type: "POST",
            beforeSend: function () {
              if (ajaxReq != 'ToCancelPrevReq' && ajaxReq.readyState < 4) {
                  ajaxReq.abort();
              }
               setTimeout(function(){
                 // printBotText('Typing');
                 chatScroll();
               },3000);  
            },
            success: function (result) {
              // debugger;
              console.log("result1",result);
              if (result.Status == 1) {
                $("#threadid").val(result.thread_id);
                 // console.log(result);
                 
                  setTimeout(function(){
                    printBotText(result.Message);
                    updateDateTime();
                    
                    $('.mess_text span').each(function() {
                      var text = $(this).text();
                      var htmlText = convertLinksToHTML(text);
                      $(this).html(htmlText);
                    });
                    // check the new text
                    var html = $('.mess_center_chat').html();
                    // overwrite the old text
                    setWithExpiry('Custom_chat', html, 1);
                  },3000);  
                  
                } 
            },
            error: function (result) {
                // debugger;
            },
          });
        }
      }
  });
  
// Function to detect if the user is using an Android device
function isAndroid() {
    return /Android/i.test(navigator.userAgent);
}

// Function to detect if the user is using an iOS device
function isIOS() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}

// Function to detect if the user is using a Windows device
function isWindows() {
    return /Win/i.test(navigator.platform);
}

// Function to detect if the user is using a Mac device
function isMac() {
    return /Mac/i.test(navigator.platform);
}

// Function to redirect the user based on their device type
function redirectToApp() {
    if (isAndroid()) {
        window.location.href = "https://play.google.com/store/apps/details?id=lifeinlilacstore.android.app&pcampaignid=web_share";
    } else if (isIOS()) {
        window.location.href = "https://apps.apple.com/us/app/life-in-lilac/id1609019610";
    } else if (isWindows()) {
        window.location.href = "https://play.google.com/store/apps/details?id=lifeinlilacstore.android.app&pcampaignid=web_share";
    } else if (isMac()) {
        window.location.href = "https://apps.apple.com/us/app/life-in-lilac/id1609019610";
    } else {
        console.log('not detected!!!')
    }
}
document.getElementById("downloadButton").addEventListener("click", redirectToApp);


// Function to get a real time  
function updateDateTime() {
  var date = new Date();
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12;
  hours = hours ? hours : 12; // Handle midnight
  minutes = minutes < 10 ? '0' + minutes : minutes;
  var dateTimeString = hours + ':' + minutes + ' ' + ampm; 
 $('.mess_time').text(dateTimeString);
}
setInterval(updateDateTime, 1000);
updateDateTime();
  
});